import React from "react";
import { NavLink } from "react-router-dom";

const CostumesList = ({ costumes, filmId }) => {
  return (
    <aside className="menu">
      <p className="menu-label">Costumes</p>
      <ul className="menu-list">
        <li>
          <NavLink
            to={`/films/${filmId}/costumes/overview`}
            activeClassName="is-active">
            Overview
          </NavLink>
        </li>
        <hr />
        {costumes?.map((costume, idx) => {
          return (
            <li key={idx}>
              <NavLink
                to={`/films/${filmId}/costumes/${costume.id}/edit`}
                title={costume.name}
                activeClassName="is-active"
                isActive={(match, location) => {
                  return location.pathname.startsWith(
                    `/films/${filmId}/costumes/${costume.id}`
                  );
                }}>
                {costume.name}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default CostumesList;
